import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from "react-toastify";
import Textarea from "../../../components/text-area";
import { ADMIN_SUBSCRIPTION } from "../../../action/apiPath";
import { CallWithAuth } from "../../../action/apiActions";
import { showToast } from "../../../util/toastHelper";
import Loading from "react-fullscreen-loading";
import { ADMINPROMPTPAGE } from "../../../util/path";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor
import { Editor } from "@tinymce/tinymce-react";

const MySwal = withReactContent(Swal);


const AdminSubscriptionPageEdit = () => {
 const { id } = useParams();
 console.log(id);

 const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const textareaRef = useRef(null);


  const [formData, setFormData] = useState({
    name: null,
    price: null,
    number_of_reports: null,
    description: null,
  });

  React.useEffect(() => {
      getSpecificPrompts();
    },[id]
  );

  const getSpecificPrompts = async () => {
    try {
      if (!id) {
        return;
      }
      setIsLoading(true);
      const response = await CallWithAuth("GET", `${ADMIN_SUBSCRIPTION}/${id}`);
      if (response.res.status == 200) {
        console.log(response.res?.data?.data);
        let apiData = response.res?.data?.data;
        setFormData((prev) => ({
          ...prev,
          name: apiData?.name || null,
          price: apiData?.price || null,
          number_of_reports: apiData?.number_of_reports || null,
          description: apiData?.description || null,
        }));

        //   setPrmoptsList(response?.res?.data?.data);
      } else {
        showToast("error", response.res.data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set new height based on scrollHeight
    }
  };


  // Re-run on text change
  const [prompt, setPrompt] = useState({});

  useEffect(() => {
    adjustHeight(); // Adjust height on initial render
  }, [prompt]);
  

  const validatePromptData = (data) => {
    const errors = {};

    if (!data.name || data.name.trim() === '') {
      errors.name = "Plan name is required.";
    }

    if (!data.price || Number(data.price) === 0) {
      errors.price = "Price is required.";
    }

    if (data.number_of_reports && Number(data.number_of_reports) > 100000) {
      errors.number_of_reports = 'Number of reports cannot be more than 1,00,000';
    }

    return errors;
  };
  const saveSubscription = async () => {
    try {
      const errors = validatePromptData(formData); // Replace `Data` with your state variable
      
      if (Object.keys(errors).length > 0) {
        const firstError = Object.values(errors)[0]; // Get the first error message
        showToast("error", firstError);
        return;
      }

      let url = ADMIN_SUBSCRIPTION;
      let method = "POST";
      
      if (id) {        
        url = `${ADMIN_SUBSCRIPTION}/${id}`;     

        method="PUT";
      }
      setIsLoading(true);
      const response = await CallWithAuth(method, url, formData);
      console.log("response", response);

      if (response.res.status == 200 || response.res.status == 201) {
        showToast("success", response.res.data.message);
        
      } else {
        if (Array.isArray(response.res.data.message)) {
          showToast("error", response.res.data.message[0]);
        } else {
          showToast("error", response.res.data.message);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);

      setIsLoading(false);
    }
  };

   const handleNameChange = (e) => {
    setFormData({
      ...formData,
      name: e.target.value,
    });
  };
  
  const handlePriceChange = (e) => {
    setFormData({
      ...formData,
      price:e.target.value ? Number(e.target.value):0,
    });
  };

  const handleReportChange = (e) => {
    let n = e.target.value;
    if (n == 0) n = null;
    setFormData({
      ...formData,
      number_of_reports: n ? Number(n) : null,
    });
  };

  const handleDescriptionChange = (value) => {
  setFormData(prev => ({
    ...prev,
    description: value,
  }));
};

  //   const handleDescriptionChange = (value) => {
  //   setDescription(value);
  // };

  return (
    <>
      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <Loading
            loading
            background="rgba(236, 240, 241, 0.7)"
            loaderColor="#3498db"
          />
        </>
      )}

      <section class="create_account_block">
        <div class="site_container">
          <div class="create_account_form">

              <div className="field_block">
              <label>Plan Name</label>
              <input
               type="text"
                name="name"
                value={formData?.name}
                onChange={handleNameChange}
                //   fieldName="background info"
                className="form-control"
              />
            </div>

                <div className="field_block">
              <label>Price</label>
              <input
               type="number"
               min={1}
                name="price"
                value={formData?.price}
                onChange={handlePriceChange}
                className="form-control"

                //   fieldName="background info"
              />
            </div>

                <div className="field_block">
              <label>Number of Reports</label>
              <input
              type="number"
                name="number_of_reports"
                value={formData?.number_of_reports || ''}
                onChange={handleReportChange}
                className="form-control"

                //   fieldName="background info"
              />
            </div>
            

            <div className="field_block">
              <label>Description</label>
               <ReactQuill 
                value={formData?.description} 
                onChange={handleDescriptionChange} 
                placeholder="Enter your description here..."
              />
              {/* <Textarea
                name="description"
                value={formData?.description}
                // onChange={handleChange}
                //   fieldName="background info"
              /> */}
            </div>

            <button onClick={saveSubscription} className="button_save_prompts">
              Update
            </button>
          </div>
        </div>
      </section>
      
         <ToastContainer />
    </>
  );
 
};
export default AdminSubscriptionPageEdit;
